import { render, staticRenderFns } from "./groupAuthority.vue?vue&type=template&id=1399a2a2&"
import script from "./groupAuthority.vue?vue&type=script&lang=js&"
export * from "./groupAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "groupAuthority.vue"
export default component.exports